export const PERFIL_ROOT = 1;
export const PERFIL_ADMIN = 2;
export const PERFIL_COMITE = 4;
export const PERFIL_DOCENTE = 8;
export const PERFIL_TECNICO = 16;
export const PERFIL_DISCENTE = 32;
export const PDF_LIMIT=5*1024*1024;
export const PROFILES=[
    PERFIL_ROOT,
    PERFIL_ADMIN,
    PERFIL_COMITE,
    PERFIL_DOCENTE,
    PERFIL_TECNICO,
    PERFIL_DISCENTE
];

